import { handleActions } from 'redux-actions';
import { GET_ARTICLES, GET_ARTICLES_SUCCESS, GET_ARTICLES_ERROR, GET_ARTICLE, GET_ARTICLE_SUCCESS, GET_ARTICLE_ERROR } from '../actions/article';
import { call, put, takeLatest } from 'redux-saga/effects';
import { loadArticlesApi, loadArticleApi } from "../api/article";

function* onLoadArticlesAsync(action) {
    try {
        const response = yield call(loadArticlesApi, action.payload);
        if (response.status === 200) {
            yield put({ type: GET_ARTICLES_SUCCESS, payload: response });
        }
    } catch (e) {
        yield put({ type: GET_ARTICLES_ERROR, payload: e });
    }
}

function* onLoadArticleAsync(action) {
    try {
        const response = yield call(loadArticleApi, action.payload);
        if (response.status === 200) {
            yield put({ type: GET_ARTICLE_SUCCESS, payload: response });
        }
    } catch (e) {
        yield put({ type: GET_ARTICLE_ERROR, payload: e });
    }
}

const initialState = {
    page: 1,
    page_count: 1,
    articles: [],
    article: {},
    loading: false,
};

export function* articleSaga() {
    yield takeLatest(GET_ARTICLES, onLoadArticlesAsync);
    yield takeLatest(GET_ARTICLE, onLoadArticleAsync);
}

export default handleActions(
    {
        [GET_ARTICLES]: (state, action) => {
            return {
                ...state,
                articles: [],
                loading: true,
            };
        },
        [GET_ARTICLES_SUCCESS]: (state, action) => {
            const { page, page_count, articles } = action.payload.data;
            return {
                ...state,
                page: page,
                page_count: page_count,
                articles: articles,
                loading: false,
            };
        },
        [GET_ARTICLES_ERROR]: (state, action) => {
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        },
        [GET_ARTICLE]: (state, action) => {
            return {
                ...state,
                article: {},
                loading: true,
            };
        },
        [GET_ARTICLE_SUCCESS]: (state, action) => {
            const { article } = action.payload.data;
            return {
                ...state,
                article: article,
                loading: false,
            };
        },
        [GET_ARTICLE_ERROR]: (state, action) => {
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        }
    },
    initialState
);